module.exports = __webpack_public_path__ + "vue_assets/img/badge_deios_platinum_cl.e22d9ab6.png";